interface StatCardProps {
  title: string;
  value: string;
  subValue?: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  trend?: number;
  trendLabel?: string;
}

export default function StatCard({
  title,
  value,
  subValue,
  icon,
  iconBg,
  iconColor,
  trend,
  trendLabel,
}: StatCardProps) {
  return (
    <div className="bg-white rounded-xl p-5 border border-gray-100">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-xs text-gray-500 mb-1">{title}</p>
          <p className="text-2xl font-bold text-gray-900 leading-tight">{value}</p>
          {subValue && <p className="text-xs text-gray-400 mt-1">{subValue}</p>}
          {trend !== undefined && (
            <div className="flex items-center gap-1 mt-2">
              <div className={`w-4 h-4 flex items-center justify-center`}>
                <i className={`${trend >= 0 ? "ri-arrow-up-s-line text-green-500" : "ri-arrow-down-s-line text-red-500"} text-sm`}></i>
              </div>
              <span className={`text-xs font-medium ${trend >= 0 ? "text-green-500" : "text-red-500"}`}>
                {Math.abs(trend)}%
              </span>
              {trendLabel && <span className="text-xs text-gray-400">{trendLabel}</span>}
            </div>
          )}
        </div>
        <div className={`w-11 h-11 rounded-xl ${iconBg} flex items-center justify-center flex-shrink-0`}>
          <div className="w-6 h-6 flex items-center justify-center">
            <i className={`${icon} text-xl ${iconColor}`}></i>
          </div>
        </div>
      </div>
    </div>
  );
}
